<template>

    <v-page-body>

        <v-page-section padded>
            <template #title>Segment</template>
            <template #body>
                <v-notice>
                    <template #body>
                        <v-icon class="mb-15" symbol="action-segment" :size="80" :radius="5" />
                        <p>Import customer data with Segment:</p>
                        <p>1. Select your source on Segment’s console<br>2. Select “Add Destination” and find CrowdPower<br>3. Enter your public key and enable the integration</p>
                        <p>Your public key:</p>
                        <v-copy-box class="w-400" dark>{{ token }}</v-copy-box>
                    </template>
                    <template #footer>
                        <v-button @click.native="open">Connect with Segment</v-button>
                    </template>
                </v-notice>
            </template>
        </v-page-section>

    </v-page-body>

</template>

<script>

import ProjectApi from '@api/ProjectApi';

export default {

    data() {
        return {
            apiKeys: [],
        }
    },

    computed: {

        token() {
            let key = this.apiKeys.find(k => k.type === 'pk');
            return key.token;
        },

    },

    mounted() {
        this.getKeys();
    },

    methods: {

        getKeys() {
            this.$store.commit('loading', true);
            ProjectApi.getKeys(this.project.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.apiKeys = response.data.data;
                    this.$events.$emit('pageLoaded');
                }, () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        open() {
            window.open('https://segment.com/docs/connections/destinations/catalog/crowdpower/', '_blank');
        },

    },

}

</script>